import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Button, Spinner } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import FormikInput from '../ui/FormikInput';
import profesoresApiService from '../../services/http/profesoresApiService';
import logger from '../../services/logger';

const validationSchema = Yup.object().shape({
  empresaId: Yup.string().required('La empresa es obligatoria'),
  snombre: Yup.string().required('El nombre es obligatorio'),
  sApellidos: Yup.string().required('Los apellidos son obligatorios'),
  email2: Yup.string()
    .email('Email corporativo inválido')
    .required('El email corporativo es obligatorio'),
});

const initialValues = {
  snombre: '',
  sApellidos: '',
  nombre: '',
  domicilio: '',
  poblacion: '',
  provincia: '',
  Distrito: '',
  dni: '',
  nacionalidad: '',
  nacimiento: '',
  TFO1: '',
  TFO2: '',
  movil: '',
  email: '',
  email2: '',
  num_ss: '',
  id_additio: '',
  cobserva: '',
  empresaId: '',
};

const empresaOptions = [
  { value: 'CEDESCA', label: 'Cedesca' },
  { value: 'CNTEC', label: 'Cntec' },
];

const NuevoProfesor = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleGuardar = async (values) => {
    try {
      setLoading(true);
      const response = await profesoresApiService.upsertProfesor(values);

      // Mostrar mensaje de éxito
      toast.success(response.message || 'Profesor creado correctamente');

      // Redirigir a la ficha del profesor
      if (response.id) {
        navigate(`/profesores/${values.empresaId}/${response.id}/detalles`);
      }
    } catch (error) {
      logger.error('Error creando profesor:', error);
      toast.error('Error al crear el profesor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        onSubmit={handleGuardar}
        validationSchema={validationSchema}
      >
        {({ isSubmitting, setFieldValue, values, errors, touched }) => (
          <Form>
            <div className="row">
              <div className="col-md-4">
                <label htmlFor="empresaId" className="form-label">
                  Empresa <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-control ${
                    errors.empresaId && touched.empresaId ? 'is-invalid' : ''
                  }`}
                  id="empresaId"
                  name="empresaId"
                  value={values.empresaId}
                  onChange={(event) => setFieldValue('empresaId', event.target.value)}
                >
                  <option value="">Selecciona empresa</option>
                  {empresaOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
                {errors.empresaId && touched.empresaId && (
                  <div className="invalid-feedback d-block">{errors.empresaId}</div>
                )}
              </div>
              <div className="col-md-4">
                <FormikInput label="Nombre" name="snombre" />
              </div>
              <div className="col-md-4">
                <FormikInput label="Apellidos" name="sApellidos" />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-6">
                <FormikInput label="Nombre Completo" name="nombre" />
              </div>
              <div className="col-md-6">
                <FormikInput label="DNI" name="dni" />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-6">
                <FormikInput label="Domicilio" name="domicilio" />
              </div>
              <div className="col-md-3">
                <FormikInput label="Población" name="poblacion" />
              </div>
              <div className="col-md-3">
                <FormikInput label="Provincia" name="provincia" />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-3">
                <FormikInput label="C. Postal" name="Distrito" />
              </div>
              <div className="col-md-3">
                <FormikInput label="Nacionalidad" name="nacionalidad" />
              </div>
              <div className="col-md-3">
                <FormikInput label="Fecha Nacimiento" name="nacimiento" type="date" />
              </div>
              <div className="col-md-3">
                <FormikInput label="Nº S.Social" name="num_ss" />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-3">
                <FormikInput label="Teléfono 1" name="TFO1" />
              </div>
              <div className="col-md-3">
                <FormikInput label="Teléfono 2" name="TFO2" />
              </div>
              <div className="col-md-3">
                <FormikInput label="Móvil" name="movil" />
              </div>
              <div className="col-md-3">
                <FormikInput label="ID Additio" name="id_additio" />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-6">
                <FormikInput label="Email personal" name="email" type="email" />
              </div>
              <div className="col-md-6">
                <FormikInput label="Email corporativo" name="email2" type="email" />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <FormikInput
                  label="Observaciones"
                  name="cobserva"
                  type="textarea"
                  placeholder="Escriba observaciones..."
                />
              </div>
            </div>
            <div className="text-end mt-3">
              <Button color="success" type="submit" disabled={isSubmitting || loading}>
                {loading ? <Spinner size="sm" /> : 'Crear'}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default NuevoProfesor;
